<template lang="pug">
  #member-center-settings-individual
    .level.is-mobile
      .level-left
        .level-item
          WtTitle(h1) Edit details for {{ member.username }}
        .level-item
          BTag(
            v-if="member.programAdmin"
            type="is-action"
          ) ADMIN
      .level-right
        .level-item
          WtButton(@click.native="backToAllMembers()")
            | BACK TO ALL MEMBERS

    //- FORM
    WtTile(ancestor)
      WtTile(parent)
        WtTile(child :is-loading="deleteInProgress")
          MemberCenterSettingsIndividualForm(
            :member="member"
            :member-copy="memberCopy"
          )

    WtTile(ancestor v-if="$auth.user().isWtAdmin && member.deviceApi !== 'Manual entry'")
      WtTile(parent)
        WtTile(child v-if="member.id")
          AdminSuperDeviceDiagnostics(:member="member")

    WtTile(ancestor)
      WtTile(parent)
        WtTile(child v-if="member.id")
          MemberSettingsEditStepEntriesForm(:member="member")
    WtTile(ancestor v-if="$auth.user().isWtAdmin")
      WtTile(parent)
        WtTile(child v-if="member.id")
          MemberSettingsEditMetricEntriesForm(:member="member")
    WtTile(ancestor v-if="$auth.user().isWtAdmin").has-background-danger
      p ONLY SHOWS FOR BE WELL SUPER ADMINS
      WtTile(parent)
        WtTile(child v-if="member.id")
          MemberMilestones(:memberId="member.id")
    WtTile(ancestor v-if="$auth.user().isWtAdmin").has-background-danger
      p ONLY SHOWS FOR BE WELL SUPER ADMINS
      WtTile(parent)
        WtTile(child v-if="member.id")
          WtTitle Points
          MemberPointsTable(:memberId="member.id")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MemberCenterSettingsIndividualForm from "@@/MemberCenterAdmin/MemberCenterSettingsIndividualForm";
import MemberSettingsEditMetricEntriesForm from "@@/MemberCenterAdmin/MemberSettingsEditMetricEntriesForm";
import MemberSettingsEditStepEntriesForm from "@@/MemberCenterAdmin/MemberSettingsEditStepEntriesForm";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
import AdminSuperDeviceDiagnostics from "@@/SuperAdminDevices/DeviceDiagnostics.vue";

const MemberMilestones = () =>
  import(
    /* webpackChunkName: "MemberMilestones" */ "@@/MemberCenterAdminSuper/AdminSuperMemberMilestones"
  ).catch(() => {
    window.location.reload();
  });
const MemberPointsTable = () =>
  import(
    /* webpackChunkName: "MemberPointsTable" */ "@@/Members/Points/MemberPointsTable"
  ).catch(() => {
    window.location.reload();
  });

export default {
  name: "MemberCenterSettingsIndividual",

  components: {
    AdminSuperDeviceDiagnostics,
    WtTitle,
    WtButton,
    WtTile,
    MemberCenterSettingsIndividualForm,
    MemberSettingsEditMetricEntriesForm,
    MemberSettingsEditStepEntriesForm,
    MemberMilestones,
    MemberPointsTable
  },

  mixins: [dateUtilityMixin],

  data() {
    return {
      member: {},
      memberCopy: {}
    };
  },

  computed: {
    ...mapGetters("members", ["deleteInProgress"])
  },

  async mounted() {
    this.member = await this.fetchMember({
      memberId: this.$route.params.id,
      setMember: false
    });

    // set registeredDate to a datepicker readable format
    this.member.registeredDate = this.unixDateTime(
      this.member.registeredDate
    ).dateObject;

    // clone a copy for resetting values
    this.memberCopy = this._.cloneDeep(this.member);
  },

  methods: {
    ...mapActions("members", ["fetchMember", "setLoadedStatus"]),

    backToAllMembers() {
      this.$router.push({ name: "MemberCenter" });

      this.setLoadedStatus({
        key: "memberLoaded",
        value: false
      });
    }
  }
};
</script>

<style lang="sass">
.date-picker-columns
  margin-top: 5px

.set-date-range-button
  margin-top: 31px
</style>
